/**
 * Normalize URL for fork diff comparison.
 * Strips protocol differences, www prefix, trailing slashes, query params, and hash.
 * Matches server-side Session.normalizeUrl() logic but also normalizes protocol and www.
 */
export function normalizeUrlForDiff(url) {
  try {
    const u = new URL(url);
    u.protocol = 'https:';
    u.hostname = u.hostname.replace(/^www\./, '');
    u.pathname = u.pathname.replace(/\/+$/, '');
    u.search = '';
    u.hash = '';
    return u.toString();
  } catch {
    return url;
  }
}
